import React from 'react';
import { brand, footerLinks } from '../../data/mock';
import { Instagram, Facebook, Youtube } from 'lucide-react';

const Footer = () => (
  <footer className="bg-[#0b0e12] text-white">
    <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-10">
      <div className="grid md:grid-cols-12 gap-10 md:gap-6">
        <div className="md:col-span-4">
          <div className="font-serif tracking-[0.42em] text-lg">{brand.name}</div>
          <div className="mt-1 tracking-[0.32em] text-[10px] text-white/60">{brand.location}</div>
          <p className="mt-8 text-white/70 font-light max-w-sm leading-relaxed">
            A house of quiet luxury on the shore of the Bosphorus — 129 rooms, four restaurants, and a garden opening to the water.
          </p>
          <div className="mt-8 space-y-2 text-[13px] text-white/70">
            <div>{brand.address}</div>
            <div><a href={`tel:${brand.phone.replace(/\s/g, '')}`} className="hover:text-white">{brand.phone}</a></div>
            <div><a href={`mailto:${brand.email}`} className="hover:text-white">{brand.email}</a></div>
          </div>
          <div className="mt-8 flex gap-4 text-white/70">
            <a href="#" aria-label="Instagram" className="hover:text-white"><Instagram className="w-5 h-5" strokeWidth={1.25} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-white"><Facebook className="w-5 h-5" strokeWidth={1.25} /></a>
            <a href="#" aria-label="Youtube" className="hover:text-white"><Youtube className="w-5 h-5" strokeWidth={1.25} /></a>
          </div>
        </div>

        <div className="md:col-span-2 md:col-start-6">
          <div className="tracking-[0.28em] text-[10.5px] uppercase text-white/60">The Hotel</div>
          <ul className="mt-5 space-y-3 text-[14px] text-white/85">
            {footerLinks.hotel.map((l) => (
              <li key={l}><a href="#" className="hover:text-white/60 transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="tracking-[0.28em] text-[10.5px] uppercase text-white/60">Discover</div>
          <ul className="mt-5 space-y-3 text-[14px] text-white/85">
            {footerLinks.discover.map((l) => (
              <li key={l}><a href="#" className="hover:text-white/60 transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="tracking-[0.28em] text-[10.5px] uppercase text-white/60">Brand</div>
          <ul className="mt-5 space-y-3 text-[14px] text-white/85">
            {footerLinks.brand.map((l) => (
              <li key={l}><a href="#" className="hover:text-white/60 transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
        <div className="text-[12px] text-white/50">
          © {new Date().getFullYear()} {brand.name} {brand.location}. A design showcase. Not a real booking service.
        </div>
        <div className="flex items-center gap-5">
          <a href="#" className="text-[12px] text-white/50 hover:text-white">Privacy</a>
          <a href="#" className="text-[12px] text-white/50 hover:text-white">Cookies</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
